import React from 'react';
import { checkLetter, checkPuzzle, checkWord, revealPuzzle, revealLetter, revealWord, toggleAutoCheck, clearPuzzle } from '../morphologyUtils';
import { MorphologyStore } from '../MorphologyStore';
import CustomRevealConfirmationDialog from '../../shared/CustomRevealConfirmationDialog';

const RevealConfirmationDialogCluster = () => {
  const confirmationDialogSettings = MorphologyStore.useState(s => s.toolbar.confirmationDialog);

  return (
    <>
      <CustomRevealConfirmationDialog
        store={MorphologyStore as any}
        onConfirm={clearPuzzle}
        onClose={() => {
          MorphologyStore.update(s => {
            s.toolbar.confirmationDialog.clearAllIsOpen = false;
          });
        }}
        isOpen={confirmationDialogSettings.clearAllIsOpen}
        prompt="Are you sure you want to clear the entire puzzle?"
      />
      <CustomRevealConfirmationDialog
        store={MorphologyStore as any}
        onConfirm={checkLetter}
        onClose={() => {
          MorphologyStore.update(s => {
            s.toolbar.confirmationDialog.checkLetterIsOpen = false;
          });
        }}
        isOpen={confirmationDialogSettings.checkLetterIsOpen}
      />
      <CustomRevealConfirmationDialog
        store={MorphologyStore as any}
        onConfirm={checkWord}
        onClose={() => {
          MorphologyStore.update(s => {
            s.toolbar.confirmationDialog.checkWordIsOpen = false;
          });
        }}
        isOpen={confirmationDialogSettings.checkWordIsOpen}
      />
      <CustomRevealConfirmationDialog
        store={MorphologyStore as any}
        onConfirm={checkPuzzle}
        onClose={() => {
          MorphologyStore.update(s => {
            s.toolbar.confirmationDialog.checkPuzzleIsOpen = false;
          });
        }}
        isOpen={confirmationDialogSettings.checkPuzzleIsOpen}
      />
      <CustomRevealConfirmationDialog
        store={MorphologyStore as any}
        onConfirm={toggleAutoCheck}
        onClose={() => {
          MorphologyStore.update(s => {
            s.toolbar.confirmationDialog.autocheckIsOpen = false;
          });
        }}
        isOpen={confirmationDialogSettings.autocheckIsOpen}
      />
      <CustomRevealConfirmationDialog
        store={MorphologyStore as any}
        onConfirm={revealLetter}
        onClose={() => {
          MorphologyStore.update(s => {
            s.toolbar.confirmationDialog.revealLetterIsOpen = false;
          });
        }}
        isOpen={confirmationDialogSettings.revealLetterIsOpen}
      />
      <CustomRevealConfirmationDialog
        store={MorphologyStore as any}
        onConfirm={revealWord}
        onClose={() => {
          MorphologyStore.update(s => {
            s.toolbar.confirmationDialog.revealWordIsOpen = false;
          });
        }}
        isOpen={confirmationDialogSettings.revealWordIsOpen}
      />
      <CustomRevealConfirmationDialog
        store={MorphologyStore as any}
        onConfirm={revealPuzzle}
        onClose={() => {
          MorphologyStore.update(s => {
            s.toolbar.confirmationDialog.revealAllIsOpen = false;
          });
        }}
        isOpen={confirmationDialogSettings.revealAllIsOpen}
        prompt="Are you sure you want to reveal the full puzzle? This puzzle will count as revealed and be excluded from any solve streak."
      />
    </>
  )
};

export default RevealConfirmationDialogCluster;